var _rect, _rect2, _polygon, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _polygon2, _rect10, _rect11, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 7,
    y: -1,
    fill: "#ffa62e",
    transform: "rotate(-90 8 6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 7,
    y: -4,
    fill: "#ffa62e",
    transform: "rotate(-90 8 2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f28211",
    points: "14,3 15,5 1,5 2,3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a2e4f4",
    d: "M1,7v8h14V7H1z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    x: 9,
    y: 9,
    fill: "#2583ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 3,
    y: 9,
    fill: "#2583ef"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 7,
    fill: "#fe3155",
    transform: "rotate(-90 8 2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 7,
    y: 4,
    fill: "#fe3155",
    transform: "rotate(-90 8 6)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 6,
    y: 3,
    fill: "#f0104c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 12.5,
    y: 0.5,
    fill: "#fe3155",
    transform: "rotate(-90 13.5 2)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 13.5,
    y: 4.5,
    fill: "#fe3155",
    transform: "rotate(-90 14.5 6)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0104c",
    points: "15,3 16,5 13,5 12,3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 1.5,
    y: 0.5,
    fill: "#fe3155",
    transform: "rotate(-90 2.5 2)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 0.5,
    y: 4.5,
    fill: "#fe3155",
    transform: "rotate(-90 1.5 6)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0104c",
    points: "1,3 0,5 3,5 4,3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.7d5f3fb8d523f40cc9e8a9b275af5aa3.svg";
export { ForwardRef as ReactComponent };